import { css } from 'styled-components';
import { isBreakpointToken, isTypographyToken } from './utils/index.js';
import { SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_2_XL } from '../../tokens/sizing.generated.js';
export const getTypographyStyles = (token) => {
    if (isTypographyToken(token)) {
        return css `
      font-family: ${token.fontFamily};
      letter-spacing: ${token.letterSpacing};
      font-weight: ${token.fontWeight};
      text-decoration: ${token.textDecoration};
      font-size: ${token.fontSize};
      line-height: ${token.lineHeight};
      font-stretch: ${token.fontStretch};
    `;
    }
    if (isBreakpointToken(token)) {
        const { xs, sm, md, lg, xl, xxl } = token.bp;
        const generateStyles = (base, next, bp) => {
            const properties = {
                fontFamily: 'font-family',
                letterSpacing: 'letter-spacing',
                fontWeight: 'font-weight',
                textDecoration: 'text-decoration',
                fontSize: 'font-size',
                lineHeight: 'line-height',
                fontStretch: 'font-stretch'
            };
            const keys = Object.keys(properties);
            const hasStyles = Boolean(keys.filter((prop) => base[prop] !== next[prop]).length);
            const styles = keys
                .filter((prop) => base[prop] !== next[prop])
                .map((prop) => `${properties[prop]}: ${next[prop]};`)
                .join('');
            if (!hasStyles) {
                return '';
            }
            return `@media (min-width: ${bp}) { ${styles} }`;
        };
        return css `
      font-family: ${xs.fontFamily};
      letter-spacing: ${xs.letterSpacing};
      font-weight: ${xs.fontWeight};
      text-decoration: ${xs.textDecoration};
      font-size: ${xs.fontSize};
      line-height: ${xs.lineHeight};
      font-stretch: ${xs.fontStretch};

      ${generateStyles(xs, sm, SYS_BREAKPOINT_SM)}
      ${generateStyles(sm, md, SYS_BREAKPOINT_MD)}
      ${generateStyles(md, lg, SYS_BREAKPOINT_LG)}
      ${generateStyles(lg, xl, SYS_BREAKPOINT_XL)}
      ${generateStyles(xl, xxl, SYS_BREAKPOINT_2_XL)}
    `;
    }
    return undefined;
};
//# sourceMappingURL=index.js.map